import { SIMPLIFY_MAX_ZOOM, SIMPLIFY_MIN_ZOOM } from '@/server/instrumentation/generalization.const'
import type { MapDataSource } from '../types'

export type SourcesParkingTildaId =
  | 'tilda_parkings'
  | 'tilda_parkings_cutouts'
  | 'tilda_parkings_no'
  | 'tilda_parkings_off_street'

export const sourcesParkingTilda: MapDataSource<SourcesParkingTildaId>[] = [
  {
    id: 'tilda_parkings',
    // NOTE: We have the lines, the labels and the areas (as "shadow" data) in one response
    tileTables: [
      'parkings',
      'parkings_edges',
      'parkings_edges_labels',
      'parkings_labels',
      'parkings_separate',
    ],
    minzoom: SIMPLIFY_MIN_ZOOM,
    // We need to apply a higher maxzoom here so the data from parkings_separate gets loaded that is only visible starting at 17
    // We could add the "separate" from 14 (our default) and only hide it visually.
    // But I assume that this approach has smaller data (and higher geometric accuracy).
    // maxzoom: SIMPLIFY_MAX_ZOOM,
    maxzoom: 17, // See processing/topics/parking/7_finalize_parkings.sql:89
    attributionHtml:
      '<a href="https://www.openstreetmap.org/copyright">© OpenStreetMap</a>; <a href="https://tilda-geo.de">tilda-geo.de</a>',
    licence: 'ODbL',
    promoteId: 'id',
    osmIdConfig: { osmTypeId: 'id' },
    inspector: {
      enabled: true,
      highlightingKey: 'id',
      documentedKeys: [
        'parking',
        'informal__if_present',
        'capacity',
        'staggered__if_present',
        'orientation',
        'direction__if_present',
        'composit_condition_category',
        'reason__if_present',
        'traffic_sign',
        'zone__if_present',
        'covered__if_present',
        'location__if_present',
        'markings__if_present',
        'composit_surface_smoothness',
        'area',
        // 'side',
        // Road
        'road',
        'road_name',
        'road_width__if_present',
        'operator_type',
        'road_oneway__if_present',
        // OTHER
        'composit_mapillary',
      ],
    },
  },
  {
    id: 'tilda_parkings_cutouts',
    tileTables: ['parkings_cutouts'],
    minzoom: SIMPLIFY_MIN_ZOOM,
    maxzoom: 17, // higher than default to fix geometric precision for circles and such
    attributionHtml:
      '<a href="https://www.openstreetmap.org/copyright">© OpenStreetMap</a>; <a href="https://tilda-geo.de">tilda-geo.de</a>',
    licence: 'ODbL',
    promoteId: 'id',
    osmIdConfig: { osmTypeId: 'id' },
    inspector: {
      enabled: true,
      highlightingKey: 'id',
      documentedKeys: [
        //
        'category',
        'buffer_radius__if_present',
      ],
    },
  },
  {
    id: 'tilda_parkings_no',
    tileTables: ['parkings_no'],
    minzoom: SIMPLIFY_MIN_ZOOM,
    maxzoom: SIMPLIFY_MAX_ZOOM,
    attributionHtml:
      '<a href="https://www.openstreetmap.org/copyright">© OpenStreetMap</a>; <a href="https://tilda-geo.de">tilda-geo.de</a>',
    licence: 'ODbL',
    promoteId: 'id',
    osmIdConfig: { osmTypeId: 'id' },
    inspector: {
      enabled: true,
      highlightingKey: 'id',
      documentedKeys: [
        //
        'reason__if_present',
        'parking',
        'composit_mapillary',
      ],
    },
  },
  {
    id: 'tilda_parkings_off_street',
    tileTables: [
      'off_street_parking_areas',
      'off_street_parking_area_labels',
      'off_street_parking_points',
    ],
    minzoom: SIMPLIFY_MIN_ZOOM,
    maxzoom: 17, // higher than default to fix geometric precision for circles and such
    attributionHtml:
      '<a href="https://www.openstreetmap.org/copyright">© OpenStreetMap</a>; <a href="https://tilda-geo.de">tilda-geo.de</a>',
    licence: 'ODbL',
    promoteId: 'id',
    osmIdConfig: { osmTypeId: 'id' },
    inspector: {
      enabled: true,
      highlightingKey: 'id',
      documentedKeys: [
        'parking',
        'informal__if_present',
        'capacity',
        'orientation__if_present',
        'direction__if_present',
        'composit_condition_category',
        'traffic_sign',
        'zone__if_present',
        'covered__if_present',
        'location__if_present',
        'markings__if_present',
        'reason__if_present',
        'composit_surface_smoothness',
        'area',
        'operator_type',
        'composit_mapillary',
      ],
    },
  },
]
